import { render, staticRenderFns } from "./ImageEditor.vue?vue&type=template&id=e5b54650&scoped=true&"
import script from "./ImageEditor.vue?vue&type=script&lang=js&"
export * from "./ImageEditor.vue?vue&type=script&lang=js&"
import style0 from "./ImageEditor.vue?vue&type=style&index=0&id=e5b54650&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5b54650",
  null
  
)

export default component.exports